import secureApi from "../services/secureApi";
// Get Staff List
export const getStaffListApi = async ({ page = 1, pageSize = 10 } = {}) => {
  try {
    const payload = {
      role: "STAFF",
      page,
      limit: pageSize,
    };
    const response = await secureApi.post(
      "/admin/staff/list",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Staff List Error:", error);
    throw error;
  }
};

// Get Staff By ID
export const getStaffByIdApi = async (staffId) => {
  try {
    const response = await secureApi.get(
      `/admin/staff/view/${staffId}`
    );
    return response.data;
  } catch (error) {
    console.error("Get Staff Error:", error);
    throw error;
  }
};
// Add Staff
export const addStaffApi = async (data) => {
  try {
    const { fullName, email, gender, mobileCountryCode, role } = data;
    const response = await secureApi.post(
      "/admin/staff/add",
      { fullName, email, gender, mobileCountryCode, role }
    );
    return response.data;
  } catch (error) {
    console.error("Add Staff Error:", error);
    throw error;
  }
};
// Update Staff
export const updateStaffApi = async (staffId, data) => {
  return editStaffApi({
    staffId: staffId,
    ...data
  });
};
// Get Admin List
export const getAminListApi = async () => {
  try {
    const payload = {
      role: "ADMIN"
    };
    const response = await secureApi.post(
      "/admin/staff/list",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Admin List Error:", error);
    throw error;
  }
};

// View Staff (alias of Get Staff By ID)
export const viewStaffApi = async (staffId) => {
  return getStaffByIdApi(staffId);
};

// Edit Staff
export const editStaffApi = async (data) => {
  try {
    const response = await secureApi.post(
      "/admin/staff/edit",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Edit Staff Error:", error);
    throw error;
  }
};
